// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hukmgamisjjgulkqacxm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1a21nYW1pc2pqZ3Vsa3FhY3htIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM0MzIwOTgsImV4cCI6MjA3OTAwODA5OH0.eK2fy-aqD93ld0mxf9j5q1cKcEpx1nU6t0GOg70EiDs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 0,
    },
  },
  global: {
    headers: {
      'x-client-info': 'supabase-js-web/2.75.0',
    },
  },
});